/**
 * Application-layer AES-256-GCM payload encryption (must match NestJS).
 */
export const PAYLOAD_ENCRYPTION = {
  /** Envelope version; bump when wire format changes */
  VERSION: 1,
  /** JSON body wrapper key for encrypted payloads */
  BODY_KEY: '__enc',
  /** Request/response headers */
  HEADER_ENCRYPTED: 'X-Payload-Encrypted',
  HEADER_VERSION: 'X-Encryption-Version',
  /** AES-GCM IV length (bytes) */
  IV_LENGTH: 12,
  /** AES-GCM auth tag (bits) */
  TAG_LENGTH: 128,
} as const;

export type EncryptedEnvelopeV1 = {
  v: number;
  iv: string;
  data: string;
};
